import PropTypes from "prop-types";
import React from 'react';
import IconBoxData1 from '../../data/iconBox/icon-box1.json';
import IconBox1 from '../../components/IconBox/IconBox1.jsx';
import SectionTitle from '../../components/SectionTitles/SectionTitle';

const ServiceIconBox = ({ classOption }) => {
    return (
        <div className={`section section-padding-t90-b100 ${classOption}`}>
            <div className="container">

                <SectionTitle
                    title="We create a unique action plan for new startups and brands"
                    subTitle=" Let us take care of all business setup processes and you focus on your business goals."
                />

                <div className="row row-cols-lg-3 row-cols-md-2 row-cols-sm-2 row-cols-1 mb-n6">

                    {IconBoxData1 && IconBoxData1.slice(0, 3).map((single, key) => {
                            return(
                                <div key={key} className="col mb-6" data-aos="fade-up">
                                    <IconBox1 classOption="box-border" data={single} key={key} />
                                </div>
                            ); 
                    })}

                </div>

            </div>
        </div>
    )
}

ServiceIconBox.propTypes = {
    classOption: PropTypes.string
  };
  ServiceIconBox.defaultProps = {
    classOption: "section section-padding-t90-b100"
};

export default ServiceIconBox;
